<script lang="ts">
  import { onMount } from 'svelte';
  import Swiper from 'swiper';
  import { Navigation } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/navigation';
  import type { SuccessCases } from '../types';

  export let cases: SuccessCases['cases'];

  let element: HTMLDivElement;

  onMount(async () => {
    new Swiper(element, {
      // Optional parameters
      modules: [Navigation],
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 0,
      breakpoints: {
        768: {
          spaceBetween: 10,
        },
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
</script>

<head>
  <link
    href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap"
    rel="stylesheet"
  />
</head>

<div class="swiper sample-slider" bind:this={element}>
  <div class="success-slider-holder swiper-wrapper">
    {#each cases as { description1, description2, description3, heading1, heading2, heading3, image, title }}
      <div class="success-slider swiper-slide">
        <div class="succes-slider-top">
          <h3 class="h3">{@html heading1.value}</h3>
          <p class="text">{@html description1.richText}</p>
        </div>
        <div class="success-image">
          <img src={image.value} alt={title.value} />
        </div>
        <div class="success-content">
          <div class="success-bullets">
            <p class="text--bold">{@html heading2.value}</p>
            <p class="text">
              {@html description2.richText}
            </p>
          </div>
          <div class="stroke" />
          <div class="success-bullets">
            <p class="text--bold">{@html heading3.value}</p>
            <p class="text">
              {@html description3.richText}
            </p>
          </div>
        </div>
      </div>
    {/each}
  </div>
  <div class="swiper-arrows">
    <div class="swiper-button-prev">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M13.2069 17.293L8.91394 13H18.4999V11H8.91394L13.2069 6.70697L11.7929 5.29297L5.08594 12L11.7929 18.707L13.2069 17.293Z"
          fill="#111111"
          fill-opacity="0.64"
        />
      </svg>
    </div>
    <div class="swiper-button-next">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M11.793 17.293L13.207 18.707L19.914 12L13.207 5.29297L11.793 6.70697L16.086 11H6.5V13H16.086L11.793 17.293Z"
          fill="#111111"
          fill-opacity="0.64"
        />
      </svg>
    </div>
  </div>
</div>

<!-- <div class="swiper succes-swiper" bind:this={element}>
  <div class="success-slider-holder swiper-wrapper">
    <div class="success-slider swiper-slide">
      <div class="succes-slider-top">
        <h3 class="h3">Zoe 1</h3>
        <p class="text">Aggressive and Anxious 3-Year-Old German Shepherd.</p>
      </div>
      <div class="success-image">
        <img
          src="img/success1.webp"
          alt="Owner teaching the commands to pup called Zoe"
        />
      </div>
      <div class="success-content">
        <div class="success-bullets">
          <p class="text--bold">Training Fix</p>
          <p class="text">
            Tailored Behavioral Focusing on Socialization Skills and Confidence
            Building
          </p>
        </div>
        <div class="stroke" />
        <div class="success-bullets">
          <p class="text--bold">Transformation</p>
          <p class="text">
            In 12 Days, Zoe became a calmer, more sociable dog. His aggression
            significantly decreased, making walks and visits enjoyable.
          </p>
        </div>
      </div>
    </div>
    <div class="success-slider swiper-slide">
      <div class="succes-slider-top">
        <h3 class="h3">Zoe2</h3>
        <p class="text">Aggressive and Anxious 3-Year-Old German Shepherd.</p>
      </div>
      <div class="success-image">
        <img
          src="img/success2.webp"
          alt="Owner teaching the commands to pup called Zoe"
        />
        <p class="text-large--bold success-image-text">Pup Name: Lucy</p>
      </div>
      <div class="success-content">
        <div class="success-bullets">
          <p class="text--bold">Training Fix:</p>
          <p class="text">
            Our program targeted her energy into constructive activities,
            combining exercise with obedience training.
          </p>
        </div>
        <div class="stroke" />
        <div class="success-bullets">
          <p class="text--bold">Transformation:</p>
          <p class="text">
            In 9 Days: Lucy has become an exemplary pet, excelling in obedience
            and transforming her energy into positive behaviors.
          </p>
        </div>
      </div>
    </div>
    <div class="success-slider swiper-slide">
      <div class="succes-slider-top">
        <h3 class="h3">Zoe 3</h3>
        <p class="text">Aggressive and Anxious 3-Year-Old German Shepherd.</p>
      </div>
      <div class="success-image">
        <img
          src="img/success3.webp"
          alt="Owner teaching the commands to pup called Zoe"
        />
        <p class="text-large--bold success-image-text">Pup Name: Toby</p>
      </div>
      <div class="success-content">
        <div class="success-bullets">
          <p class="text--bold">Training Fix:</p>
          <p class="text">
            Focused on impulse control and basic commands, we used gentle,
            consistent training methods tailored to Toby's spirited personality.
          </p>
        </div>
        <div class="stroke" />
        <div class="success-bullets">
          <p class="text--bold">Transformation:</p>
          <p class="text">
            In 17 Days: Toby has become an attentive and well-behaved dog,
            bringing peace and joy to his household.
          </p>
        </div>
      </div>
    </div>
    <div class="success-slider swiper-slide">
      <div class="succes-slider-top">
        <h3 class="h3">Zoe</h3>
        <p class="text">Aggressive and Anxious 3-Year-Old German Shepherd.</p>
      </div>
      <div class="success-image">
        <img
          src="img/success3.webp"
          alt="Owner teaching the commands to pup called Zoe"
        />
        <p class="text-large--bold success-image-text">Pup Name: Toby</p>
      </div>
      <div class="success-content">
        <div class="success-bullets">
          <p class="text--bold">Training Fix:</p>
          <p class="text">
            Focused on impulse control and basic commands, we used gentle,
            consistent training methods tailored to Toby's spirited personality.
          </p>
        </div>
        <div class="stroke" />
        <div class="success-bullets">
          <p class="text--bold">Transformation:</p>
          <p class="text">
            In 17 Days: Toby has become an attentive and well-behaved dog,
            bringing peace and joy to his household.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="swiper-arrows">
    <div class="swiper-button-prev" on:click={click}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M13.2069 17.293L8.91394 13H18.4999V11H8.91394L13.2069 6.70697L11.7929 5.29297L5.08594 12L11.7929 18.707L13.2069 17.293Z"
          fill="#111111"
          fill-opacity="0.64"
        />
      </svg>
    </div>
    <div class="swiper-button-next">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M11.793 17.293L13.207 18.707L19.914 12L13.207 5.29297L11.793 6.70697L16.086 11H6.5V13H16.086L11.793 17.293Z"
          fill="#111111"
          fill-opacity="0.64"
        />
      </svg>
    </div>
  </div>
</div> -->
